<template>
  <div>
    <section>
      <v-snackbar v-model="snackbar.model" timeout="5000">{{
        snackbar.text
      }}</v-snackbar>
    </section>
    <section>
      <template>
        <v-container fluid>
          <v-row justify="center" align="center">
            <v-col cols="12">
              <Subheader
                icon="mdi-bell"
                title="E-Mail-Benachrichtigungen"
              ></Subheader>
              <div class="mt-7">
                <v-card>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <div class="subtitle-1 mb-4">
                            Steuere, wann Benutzer über Änderungen bei
                            Aufgabenzuweisungen per E-Mail benachrichtigt
                            werden.
                          </div>
                          <v-checkbox
                            v-model="notificationsEnabled"
                            :loading="loading"
                            label="E-Mail-Benachrichtigungen senden"
                            persistent-hint
                            hint="Wenn aktiviert, werden Benutzer bei Änderungen an Aufgabenzuweisungen automatisch per E-Mail benachrichtigt."
                            color="primary"
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="12" v-if="!notificationsEnabled">
                          <v-alert type="warning" outlined dense>
                            <strong>Hinweis:</strong> E-Mail-Benachrichtigungen
                            sind aktuell deaktiviert. Änderungen an
                            Aufgabenzuweisungen werden nicht per E-Mail
                            gemeldet.
                          </v-alert>
                        </v-col>
                        <v-col cols="12" v-if="pendingNotificationCount > 0">
                          <v-alert type="warning" outlined dense>
                            <strong>{{ pendingNotificationCount }}</strong>
                            ausstehende
                            {{
                              pendingNotificationCount === 1
                                ? "Benachrichtigung"
                                : "Benachrichtigungen"
                            }}
                            warten auf Versand.
                          </v-alert>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      depressed
                      color="success"
                      :loading="loading"
                      @click="saveSettings()"
                    >
                      <v-icon left>mdi-content-save</v-icon>
                      Speichern
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
  </div>
</template>

<script>
import Subheader from "@/components/_systemwide/Subheader.vue";
import { MEMBER_MANAGEMENT } from "@/store/modules.js";
import { UPDATE_MEMBER_MANAGEMENT_CONFIG } from "@/store/action-types.js";

export default {
  name: "config-tab-assignments",
  components: {
    Subheader,
  },
  props: {
    organization: Object,
  },
  data() {
    return {
      snackbar: {
        model: false,
        text: "",
      },
      loading: false,
      notificationsEnabled: true,
      pendingNotificationCount: 0,
    };
  },
  mounted() {
    this.notificationsEnabled = !(
      this.$store.state.organization.activeOrganization?.config
        ?.memberManagement?.assignments?.notificationsPaused || false
    );
  },
  computed: {},
  methods: {
    saveSettings() {
      this.loading = true;

      this.$store
        .dispatch(`${MEMBER_MANAGEMENT}${UPDATE_MEMBER_MANAGEMENT_CONFIG}`, {
          organizationId: this.$route.params.organizationId,
          type: "onlyAssignmentsConfig",
          notificationsPaused: !this.notificationsEnabled,
        })
        .then(() => {
          this.loading = false;
          this.snackbar.model = true;
          this.snackbar.text = "Einstellungen erfolgreich gespeichert";
          // Reload pending count after save
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
          this.snackbar.model = true;
          this.snackbar.text = "Fehler beim Speichern der Einstellungen";
        });
    },
  },
  watch: {
    organization: {
      handler() {
        this.notificationsEnabled = !(
          this.$store.state.organization.activeOrganization?.config
            ?.memberManagement?.assignments?.notificationsPaused || false
        );
      },
      deep: true,
    },
  },
};
</script>
